import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import React, { Component } from 'react';
import './libraryIntegration.css';
import apiDocs from "./apiDocsConfig";
import ReactToPrint from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class LibraryIntegration extends Component {

    render() {
        return (
            <>
                <RoutingMenu activeScreen="libraryIntegration" />
                <div className="col-md-12 api-doc" ref={el => this.componentRef = el}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h3 className="mb-0">Library Integration API Documentation</h3>

                        <div title="Click to Print">
                            <ReactToPrint
                                trigger={() => (
                                    <button
                                        className="btn outline-button rfid-print-button"
                                        style={{ borderRadius: '5px' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={['fas', 'print']}
                                            className="mr-1"
                                            style={{ color: '#0465AC' }}
                                        />
                                        Print
                                    </button>
                                )}
                                content={() => this.componentRef}
                            />
                        </div>
                    </div>

                    <h4>Introduction</h4>
                    <p>
                        Welcome to the Library API Documentation, designed to support RFID-based library integration for automated resource identification, issuing, and tracking.
                    </p>

                    <h4>Base URL</h4>
                    <div className="api-box">
                        https://portal.vmedulife.com/api/library/libraryPublicIntegration.php
                    </div>

                    <h4>Authentication</h4>
                    <p>
                        To interact with the Library API, ensure the inclusion of basic authorization in your request headers.
                    </p>
                    <p><span className='bold'>Authorization: </span> Basic Secret Key</p>

                    {/* NOTE SECTION */}
                    <div className="api-note">
                        <b>Note:</b>
                        <ul>
                            <li>All input parameter values must be <b>Base64 encrypted</b> before sending the request.</li>
                            <li>
                                To generate the <b>Secret Key</b>, navigate to:
                                <br />
                                <b>Access Management Module → Secret Key Generator Tab</b>
                            </li>
                        </ul>
                    </div>

                    {apiDocs.map((api, index) => (
                        <div key={api.id} className="api-section">

                            <h4 className="api-title">
                                <span className="api-index">{index + 1}. </span>
                                {api.title}
                            </h4>

                            <h4>API Name</h4>
                            <div className="api-box">
                                {api.apiName}
                            </div>

                            <p>{api.description}</p>

                            <h5>Request Parameters</h5>
                            <ul>
                                {api.requestParams.map((param, i) => (
                                    <li key={i}>
                                        <b>{param.name}</b>
                                        {param.required && " (required)"} – {param.desc}
                                    </li>
                                ))}
                            </ul>

                            {api.curlURL && (
                                <>
                                    <h5>cURL Request</h5>
                                    <pre className="code-block">
                                        {api.curlURL.trim()}
                                    </pre>
                                </>
                            )}

                            {api.successResponse && (
                                <>
                                    <h5>Success Response</h5>
                                    <pre className="code-block">
                                        {JSON.stringify(api.successResponse, null, 2)}
                                    </pre>
                                </>
                            )}

                            {api.errorResponse && (
                                <>
                                    <h5>Error Response</h5>
                                    <pre className="code-block error">
                                        {JSON.stringify(api.errorResponse, null, 2)}
                                    </pre>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </>
        )
    }
}

export default LibraryIntegration;